import { createSlice } from '@reduxjs/toolkit';
import { WebStorageClient } from "../clients/webStorage.client";
const date = WebStorageClient.getAlertSelectedDate({ forReducer: true });

const initialState = {
  selectedDate: date,
};

const actionsSelectedDateSlice = createSlice({
  name: 'actionsSelectedDate',
  initialState,
  reducers: {
    setSelectedDateAction(state, action) {
      state.selectedDate = action.payload;
    },
  },
});

export const { setSelectedDateAction } = actionsSelectedDateSlice.actions;

export default actionsSelectedDateSlice.reducer;
